<script lang="ts">import { Currency } from "../api/api";
import Tier1Background from "../images/Tier1_bckg.png";
import Tier2Background from "../images/Tier2_bckg.png";
import { formatLargeNumbers } from "../utils";
import { Card } from "@infinitro/card";
import { stateUi } from "@infinitro/config";
import { loggedIn, providerBasePath, toSiteUrl } from "@infinitro/global";
import { CurrencyIcon } from "@infinitro/icons";
import { Text } from "@infinitro/text";
export let liveWin;
// Determine tier based on dynamic thresholds from parent
const getTier = () => {
	if (liveWin.tier1Threshold && liveWin.multiplier >= liveWin.tier1Threshold) return 1;
	if (liveWin.tier2Threshold && liveWin.multiplier >= liveWin.tier2Threshold) return 2;
	return null;
};
// Get tier-specific styling
const tier = getTier();
const tierConfig = {
	1: {
		background: Tier1Background,
		gradient: "linear-gradient(to bottom, #730101 0%, #3D0000 100%)",
		border: "#FDD97C",
		shadow: "0 0 11px #FA4109",
		winValueColor: "#FF4848"
	},
	2: {
		background: Tier2Background,
		gradient: "linear-gradient(to bottom, #00298E 0%, #00154B 100%)",
		border: "#35FCFE",
		shadow: "0 0 11px #35FBFE",
		winValueColor: null
	}
};
// Truncate username if too long
const truncatedUsername = () => {
	const username = liveWin.username || "Anonymous";
	return username.length > 15 ? `${username.slice(0, 13)}...` : username;
};
// Format and truncate game name from slug
const truncatedGameName = () => {
	// Replace underscores and hyphens with spaces, then title case
	const formatted = liveWin.gameSlug.replace(/[_-]/g, " ").split(" ").map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ");
	return formatted.length > 15 ? `${formatted.slice(0, 13)}...` : formatted;
};
// Handle currency type mismatch - filter out future value sentinel
const getCurrency = () => {
	return liveWin.currency === "%future added value" ? Currency.btc : liveWin.currency;
};
$: useAlternative3 = $stateUi.liveWins.liveWinsStyle === "alternative3";
</script>

<div
	class="live-win-card"
	class:tier-1={tier === 1}
	class:tier-2={tier === 2}
	class:live-win-card-alternative3={useAlternative3}
	style={tier && !useAlternative3
		? `background-image: url(${tierConfig[tier].background}), ${tierConfig[tier].gradient}; border: 1px solid ${tierConfig[tier].border}; box-shadow: ${tierConfig[tier].shadow};`
		: 'border: 1px solid var(--color-neutral-700);'}
>
	<!-- Left column: Game tile -->
	<div class="game-tile">
		<a
			href={toSiteUrl(
				`${providerBasePath(liveWin.providerSlug)}${liveWin.providerSlug}/${liveWin.gameSlug}`,
				$loggedIn
			) || '#'}
		>
			<Card
				item={{
					game: liveWin.gameSlug,
					prov: liveWin.providerSlug,
					tile: `${providerBasePath(liveWin.providerSlug)}${liveWin.providerSlug}/${liveWin.gameSlug}`,
					alt: `${liveWin.gameSlug} by ${liveWin.providerSlug}`
				}}
				thumbnailBig
				showOverlay={false}
				width="54px"
				height="72px"
				maxWidth="54px"
				maxHeight="72px"
			/>
		</a>
	</div>

	<!-- Right column: User info, game name, win value -->
	<div class="win-info" class:win-info-alternative={useAlternative3}>
		<Text
			type="body"
			bodySize="small"
			bodyWeight="bold"
			textColor="white"
			customStyle="font-size: 14px; line-height: 16px;"
		>
			{truncatedUsername()}
		</Text>
		{#if !useAlternative3}
			<Text
				type="body"
				bodySize="small"
				bodyWeight="regular"
				textColor="gray"
				customStyle="font-size: 14px; line-height: 16px;"
			>
				{truncatedGameName()}
			</Text>
		{/if}

		<div
			class="win-value"
			style={tier && tierConfig[tier].winValueColor && !useAlternative3
				? `border-color: ${tierConfig[tier].winValueColor};`
				: ''}
		>
			<Text
				type="body"
				bodySize="small"
				bodyWeight="bold"
				textColor="success"
				customStyle="font-size: 12px; line-height: 16px; {tier && tierConfig[tier].winValueColor
					? `color: ${useAlternative3 ? 'var(--color-success-500)' : tierConfig[tier].winValueColor};`
					: ''}"
			>
				{liveWin.multiplier}x
			</Text>
			<CurrencyIcon currency={getCurrency()} size={'14'} />
			<Text
				type="body"
				bodySize="small"
				bodyWeight="bold"
				textColor="success"
				customStyle="font-size: 12px; line-height: 16px; {tier && tierConfig[tier].winValueColor
					? `color: ${useAlternative3 ? 'var(--color-success-500)' : tierConfig[tier].winValueColor};`
					: ''}"
			>
				{formatLargeNumbers(liveWin.paidCurrency)}
			</Text>
		</div>
	</div>
</div>

<style>
	.live-win-card {
		display: flex;
		height: 100%;
		width: 100%;
		gap: 0.5rem;
		border-radius: 8px;
		padding: 0.25rem;
		background-size: cover;
		background-position: center;
}

	.live-win-card-alternative3 {
		background: linear-gradient(
			to bottom,
			var(--color-background-500) 0%,
			var(--color-background-900) 100%
		);
	}

	.game-tile {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 54px;
		height: 72px;
}

	.win-info {
		display: flex;
		flex: 1 1 0%;
		flex-direction: column;
		justify-content: space-between;
		padding: 4px 8px 4px 0;
}

	.win-value {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		gap: 0.25rem;
		border: 1px solid var(--color-success-500);
		border-radius: 4px;
		padding: 2px 6px;
		width: -moz-fit-content;
		width: fit-content;
}

	.win-info-alternative {
		justify-content: center;
		gap: 0.75rem;
		border-style: none;
}
</style>
